import graphql__17a3cd31d488d5be8224 from "./__generated__/SendUsersGroupRequestMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__17a3cd31d488d5be8224;

function sendUsersGroupRequest(id, onCompleted) {
  const variables = {
    usersGroupId: id
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { sendUsersGroupRequest };
